import React from 'react';

import { IonButtons, IonIcon, IonSkeletonText, IonToolbar } from '@ionic/react';
import { chevronBackOutline, chevronForwardOutline } from 'ionicons/icons';

import Typography from 'components/Typography';

import './index.css';

const DataTableSkeleton = () => {
  return (
    <>
      <div className={'datatable-skeleton'}>
        <div className={'table-container'}>
          <table>
            <thead>
              <tr>
                <th>
                  <IonSkeletonText animated />
                </th>
                <th>
                  <IonSkeletonText animated />
                </th>
                <th>
                  <IonSkeletonText animated />
                </th>
                <th>
                  <IonSkeletonText animated />
                </th>
                <th>
                  <IonSkeletonText animated />
                </th>
              </tr>
              <tr>
                <th>
                  <IonSkeletonText animated />
                </th>
                <th>
                  <IonSkeletonText animated />
                </th>
                <th>
                  <IonSkeletonText animated />
                </th>
                <th>
                  <IonSkeletonText animated />
                </th>
                <th>
                  <IonSkeletonText animated />
                </th>
              </tr>
            </thead>
            <tbody>
              {new Array(4).fill(null).map((_, index) => (
                <tr key={index}>
                  <td>
                    <IonSkeletonText animated />
                  </td>
                  <td>
                    <IonSkeletonText animated />
                  </td>
                  <td>
                    <IonSkeletonText animated />
                  </td>
                  <td>
                    <IonSkeletonText animated />
                  </td>
                  <td>
                    <IonSkeletonText animated />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <IonToolbar className={'skeleton-datatable-pagination'}>
        <IonButtons slot={'start'}>
          <IonSkeletonText
            animated
            className={'skeleton-datatable-pagination-count'}
          />
        </IonButtons>
        <Typography variant={'title'}>
          <IonSkeletonText
            animated
            className={'skeleton-datatable-pagination-page'}
          />
        </Typography>
        <IonButtons slot={'end'}>
          <IonIcon
            icon={chevronBackOutline}
            className={'skeleton-datatable-pagination-disabled'}
          />
          <IonIcon
            icon={chevronForwardOutline}
            className={'skeleton-datatable-pagination-disabled'}
          />
        </IonButtons>
      </IonToolbar>
    </>
  );
};
export default DataTableSkeleton;
